import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import {PropertyClearUIListenerParams} from '#/DefaultViewExtensionInterfaces';

export default class SmtpConnectionUIListener extends UIListener {

    constructor() {
        super();

        this.createChain(
            'SmtpConnectionTypeUIListener',
            this.createPropertyClearUIListener(),
        );
    }

    private createPropertyClearUIListener() {
        const params: PropertyClearUIListenerParams = {
            rules: [
                {
                    propertiesToWatch: ['Host'],
                    propertiesToClear: ['Password']
                },
                {
                    propertiesToWatch: ['TenantId', 'ClientId'],
                    propertiesToClear: ['DecryptedClientSecret']
                }
            ]
        };
        return {
            uiListener: 'PropertyClearUIListener',
            params: params
        };
    }
}

ComponentManager.setUIListener('SmtpConnectionUIListener', SmtpConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.SmtpConnectionUIListener', SmtpConnectionUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');